























import { open_export } from "@/shared/utils";
import { Notif } from "@/store";
import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component({ name: "export-daily" })
export default class ExportDaily extends Vue {
  /* Constants */

  @Prop({ required: true }) readonly value!: string;

  /* Variables */

  date = null as string | null;

  /* Computed */

  public get counter(): boolean {
    if (!this.value) return false;
    return this.value.includes("counter");
  }

  /* Methods */

  @Emit("submit")
  submit(): void {
    try {
      open_export(this.value, { date: this.date });
      Notif.notif_success("Data Downloaded.");
      this.close();
    } catch (error) {
      Notif.notif_api_error(error);
    }
  }

  @Emit("input")
  close(): null {
    this.date = null;
    return null;
  }

  /* Life-cycle Methods */
}
